import 'waypoints/lib/jquery.waypoints';

export default class {

  constructor() {
    this.elements = document.querySelectorAll('[data-scroll-animation]:not(.animated)');
    this.handlerLoop();
  }

  handlerLoop() {
    [...this.elements].forEach(element => {
        this.scroll(element);
    });
  }

  scroll(element) {
    new Waypoint({
      element: element,
      handler: function (direction) {

        if (this.element.classList.contains('animated')) {
          return;
        }

        let className = ('down' === direction) ? this.element.dataset.scrollDown : this.element.dataset.scrollUp;

        if (!className) {
          return;
        }

        this.element.classList.add(className);
        this.element.classList.add('animated');
      },
      offset: window.matchMedia("(min-width: 1024px)").matches ? '75%' : '85%'
    });
  }
}

